import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const ToastMessageSlice = createSlice({
  name: "toastMessage",
  initialState: {
    message: "",
    status: "",
    color: "",
    messageOf: "",
  },
  reducers: {
    setToastMessage(
      state,
      action: PayloadAction<{
        message: string;
        status: string;
        color?: string;
        messageOf?: string;
      }>
    ) {
      state.message = action.payload.message;
      state.status = action.payload.status;
      state.color = action.payload.color || "success";
      state.messageOf = action.payload.messageOf || "mealplan";
    },
    clearToastMessage(state) {
      state.message = "";
      state.status = "";
      state.color = "";
      state.messageOf = "";
    },
  },
});

export const { setToastMessage, clearToastMessage } = ToastMessageSlice.actions;
export const toastMessageSlice = ToastMessageSlice.reducer;